import { render } from "./chatleft.vue?vue&type=template&id=4a42674c&scoped=true"
import script from "./chatleft.vue?vue&type=script&lang=js"
export * from "./chatleft.vue?vue&type=script&lang=js"

import "./chatleft.vue?vue&type=style&index=0&id=4a42674c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a42674c"]])

export default __exports__